import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { API } from '../../api';
import TutorialBienvenida from './TutorialBienvenida';
// Clases .mi/.card/.ticker/.top/.avatar/.hello/.actions/.fisio-banner del menú real de
// aterrizaje (fuente de la verdad: pages/menuInicio.css, el mismo que usa
// CanalPilarDashboard). Import explícito para que el onboarding no dependa de que otro
// componente lo haya cargado antes.
import '../../pages/menuInicio.css';

/* Asistente de bienvenida de PRIMERA VEZ (spec Ann 2026-07-09).
   Pasos: 1) crear contraseña (email pre-rellenado) · 2) condiciones (obligatorio) ·
   3) chuleta saltable (tarjetas adaptadas a lo que tiene el cliente). Foto NO aquí.
   Preview en localhost: /?onboarding=1  */

const TEAL = '#2C6675';
const TEAL2 = '#3C8696';

// En el onboarding se acepta DE FORMA DIGITAL (casilla), así que se quita el formalismo
// de firma a mano del documento legal: la línea de guiones bajos y el rótulo "Lugar, fecha y firma".
function _sinFirmaManual(html) {
  if (!html) return html;
  let out = html.replace(/_{5,}/g, '');
  out = out.replace(/Lugar,\s*fecha\s*y\s*firma\s*:?/gi,
    'Aceptas esta normativa de forma digital al marcar la casilla de abajo.');
  return out;
}

const pill = (activo) => ({
  height: 40, borderRadius: 12, border: 'none', cursor: 'pointer',
  fontWeight: 700, fontSize: 15, fontFamily: "'Montserrat', system-ui, sans-serif",
  background: activo ? `linear-gradient(135deg,${TEAL2},${TEAL})` : '#E1EAEB',
  color: activo ? '#fff' : '#7d9195', width: '100%', transition: '.15s',
});

const inputStyle = {
  width: '100%', height: 46, borderRadius: 12, border: '1px solid #dbe6e7',
  padding: '0 14px', fontSize: 15, outline: 'none', boxSizing: 'border-box',
  fontFamily: "'Montserrat', system-ui, sans-serif",
};

const ICONS = {
  cambios: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={TEAL} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4.5" width="18" height="17" rx="2.5" /><path d="M3 9.5h18M8 2.5v4M16 2.5v4" /><path d="M15.5 14.5l-4 4-2-2" /></svg>,
  canal: <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke={TEAL} strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="2.5" y="4.5" width="19" height="13" rx="2.5" /><path d="M10 9l4.5 2.5L10 14z" fill={TEAL} stroke="none" /><path d="M8 21h8" /></svg>,
  fisio: <svg width="26" height="26" viewBox="0 0 24 24" fill="#fff" stroke={TEAL} strokeWidth="1.6"><path d="M12 2l2.4 6.9L21 9l-5.4 4.3L17.6 21 12 16.9 6.4 21l2-7.7L3 9l6.6-.1z" /></svg>,
};

const _chevron = <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#9fb7b1" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 6l6 6-6 6" /></svg>;
const _pillTeal = { display: 'inline-flex', alignItems: 'center', gap: 6, height: 32, padding: '0 13px', borderRadius: 10, fontSize: 13, fontWeight: 600, cursor: 'pointer', textDecoration: 'none', color: '#2C6675', background: 'rgba(60,134,150,.12)', border: '1px solid rgba(60,134,150,.35)' };
const _ic = (path) => <span className="ic"><svg width="23" height="23" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">{path}</svg></span>;

// PASO 3 · el TUTORIAL se muestra SOBRE EL MENÚ REAL de aterrizaje (mismas clases .mi/.card).
function MenuConTutorial({ acceso, onFinish }) {
  const steps = [
    { sel: '#tut-novedades', titulo: 'Novedades', texto: 'Aquí publicamos las novedades más importantes del centro.' },
    acceso.presencial && { sel: '#tut-cambios', titulo: 'Cambia tus clases', texto: 'Aquí cambias el día u hora de tus clases cuando lo necesites.' },
    acceso.canal && { sel: '#tut-canal', titulo: 'Tus vídeos', texto: 'Aquí tienes las clases del Método en vídeo, para hacer en casa.' },
    acceso.clinica && { sel: '#tut-pautas', titulo: 'Tus pautas', texto: 'Tus pautas domiciliarias, si sigues un tratamiento en MEFIR.' },
    acceso.fisio && { sel: '#tut-fisio', titulo: 'Pide tu fisio', texto: 'Aquí reservas tu cita de fisioterapia en MEFIR.' },
    { sel: '#tut-perfil', titulo: 'Tu perfil', texto: 'Tu perfil, con el detalle de tu contratación.' },
    { sel: '#tut-bonos', titulo: 'Tus bonificaciones', texto: 'Tus bonificaciones y descuentos especiales por tu fidelidad.' },
    { sel: '#tut-opinar', titulo: 'Tu opinión', texto: 'Deja tu opinión en Google. ¡Nos ayuda muchísimo a darnos a conocer!' },
  ].filter(Boolean);

  return (
    <div style={{ minHeight: '100vh', background: 'radial-gradient(130% 70% at 50% 0%,#E1F4EF 0%,#EAF6F4 55%)', fontFamily: "'Montserrat', system-ui, sans-serif" }}>
      <div className="mi">
        {/* Marca */}
        <div style={{ display: 'flex', justifyContent: 'center', margin: '4px 0 8px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <img src="/logo-pd.png" alt="Pilar Domínguez" style={{ height: 32 }} />
            <span style={{ width: 1, height: 24, background: 'rgba(44,107,118,.3)' }} />
            <img src="/logo-mefir-trans.png" alt="MEFIR" style={{ height: 28 }} />
          </div>
        </div>

        {/* Novedades (marquesina) */}
        <div id="tut-novedades" className="ticker">
          <span className="tag"><i />Novedades</span>
          <div className="track"><div className="move"><span>¡Bienvenida al Método Pilar Domínguez!</span><span>Promoción válida hasta fin de mes</span></div></div>
        </div>

        {/* Cabecera: avatar + nombre + Salir/Opinar */}
        <div className="top" style={{ alignItems: 'center' }}>
          <div className="avatar"><span className="fb">A</span></div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <h1 className="hello">Bienvenida</h1>
          </div>
          <div className="actions">
            <span style={_pillTeal}><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" /></svg>Salir</span>
            <span id="tut-opinar" style={_pillTeal}><svg width="14" height="14" viewBox="0 0 24 24" fill="#2C6675"><path d="M12 2l2.9 6.2 6.6.6-5 4.4 1.5 6.6L12 17l-5.9 2.8 1.5-6.6-5-4.4 6.6-.6z" /></svg>¡Opinar!</span>
          </div>
        </div>

        {/* Reclamo fisio */}
        {acceso.fisio && (
          <div id="tut-fisio" className="fisio-banner" style={{ marginTop: 18 }}>
            <div className="fisio-main">
              <span className="fisio-badge"><svg width="13" height="13" viewBox="0 0 24 24" fill="#fff"><path d="M12 2l2.4 6.9L21 9l-5.4 4.3L17.6 21 12 16.9 6.4 21l2-7.7L3 9l6.6-.1z" /></svg>Fisioterapia · MEFIR</span>
              <h3 className="fisio-title">Estrena tu fisio en MEFIR</h3>
              <p className="fisio-text">Tu <b>primera visita</b>, a precio de bienvenida.</p>
              <button type="button" className="fisio-cta">Pedir cita</button>
            </div>
            <div className="fisio-num"><span className="fisio-num-big">20<small>%</small></span><span className="fisio-num-lbl">dto. 1ª visita</span></div>
          </div>
        )}

        <p className="eyebrow" style={{ margin: '22px 4px 12px' }}>Canal Pilar Domínguez · MEFIR</p>

        <div className="menu">
          {acceso.presencial && (
            <button id="tut-cambios" className="card" type="button">
              {_ic(<><rect x="3" y="4.5" width="18" height="17" rx="2.5" /><path d="M3 9.5h18M8 2.5v4M16 2.5v4" /><path d="M15.5 14.5l-4 4-2-2" /></>)}
              <div className="txt"><div className="title">Cambios Presenciales</div><div className="desc">Gestiona tus clases y cambios de horario</div></div>
              {_chevron}
            </button>
          )}
          {acceso.canal && (
            <button id="tut-canal" className="card" type="button">
              {_ic(<><rect x="2.5" y="4.5" width="19" height="13" rx="2.5" /><path d="M10 9l4.5 2.5L10 14z" fill="currentColor" stroke="none" /><path d="M8 21h8" /></>)}
              <div className="txt"><div className="title">Canal Pilar Domínguez</div><div className="desc">Clases online del Método</div></div>
              {_chevron}
            </button>
          )}
          {acceso.clinica && (
            <button id="tut-pautas" className="card" type="button">
              {_ic(<><path d="M9 2h6v3H9zM7 5h10a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z" /><path d="M9 12h6M9 16h4" /></>)}
              <div className="txt"><div className="title">MEFIR Clínica</div><div className="desc">Tus pautas domiciliarias y tratamiento</div></div>
              {_chevron}
            </button>
          )}
          <button id="tut-perfil" className="card" type="button">
            {_ic(<><circle cx="12" cy="8" r="4" /><path d="M4 21c0-4 4-6 8-6s8 2 8 6" /></>)}
            <div className="txt"><div className="title">Mi Perfil</div><div className="desc">El detalle de tu contratación</div></div>
            {_chevron}
          </button>
          <button id="tut-bonos" className="card" type="button">
            {_ic(<><path d="M20 12v9H4v-9M2 7h20v5H2zM12 22V7M12 7S9 2 6.5 3.5 8 7 12 7zM12 7s3-5 5.5-3.5S16 7 12 7z" /></>)}
            <div className="txt"><div className="title">Mis bonificaciones</div><div className="desc">Descuentos especiales por tu fidelidad</div></div>
            {_chevron}
          </button>
        </div>
      </div>

      <TutorialBienvenida steps={steps} onFinish={onFinish} />
    </div>
  );
}

export default function OnboardingBienvenida({
  email = 'tu@email.com',
  acceso = { presencial: true, canal: true, fisio: true },
  onFinish = () => {},
  pasoInicial = 0,   // para el atajo al tutorial en la demo (2 = tutorial)
}) {
  const [step, setStep] = useState(pasoInicial);
  const [pw1, setPw1] = useState('');
  const [pw2, setPw2] = useState('');
  const [reenviado, setReenviado] = useState(false);
  const [acepta, setAcepta] = useState(false);
  const [normHtml, setNormHtml] = useState('');   // normativa REAL (HTML maquetado)
  const [normMd, setNormMd] = useState('');       // fallback markdown
  const [normLoad, setNormLoad] = useState(true);
  const [leido, setLeido] = useState(false);      // ha llegado al final del documento
  const normRef = useRef(null);

  // Detecta si la normativa se ha leído hasta el final (o si es tan corta que no hace scroll).
  const _checkFinal = (el) => {
    if (!el) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 8) setLeido(true);
  };
  useEffect(() => {
    // Si el documento cabe entero sin scroll, ya se considera leído.
    const el = normRef.current;
    if (el && el.scrollHeight <= el.clientHeight + 8) setLeido(true);
  }, [normHtml, normMd, normLoad]);

  // Normativa REAL: flujo cliente = /client/normativa ({html}); preview/admin = plantilla NORMATIVA.
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const r = await axios.get(`${API}/client/normativa`);
        if (alive && r.data?.html) { setNormHtml(_sinFirmaManual(r.data.html)); setNormLoad(false); return; }
      } catch (e) { /* no es cliente → fallback admin */ }
      try {
        const r = await axios.get(`${API}/settings/legal-templates`);
        const list = Array.isArray(r.data) ? r.data : (r.data?.templates || []);
        const norm = list.find(t => t.type === 'NORMATIVA' && t.is_print_default)
          || list.find(t => t.type === 'NORMATIVA' && t.visible_canal)
          || list.find(t => t.type === 'NORMATIVA');
        if (norm) {
          const d = await axios.get(`${API}/settings/legal-templates/${norm.id}`);
          if (alive) {
            if (d.data?.html_maquetado) setNormHtml(_sinFirmaManual(d.data.html_maquetado));
            else setNormMd(_sinFirmaManual(d.data?.content_markdown || norm.content_markdown || ''));
          }
        }
      } catch (e) { /* sin acceso → aviso */ }
      if (alive) setNormLoad(false);
    })();
    return () => { alive = false; };
  }, []);

  const chuleta = [
    acceso.presencial && { icon: ICONS.cambios, t: 'Gestiona tus cambios de clase', d: 'Cambia el día u hora de tus clases presenciales cuando lo necesites, desde tu móvil.' },
    acceso.canal && { icon: ICONS.canal, t: 'Canal de vídeos del Método', d: 'Todas las clases del Método Pilar Domínguez en vídeo, para hacer en casa a tu ritmo.' },
    acceso.fisio && { icon: ICONS.fisio, t: 'Pide tu cita de fisioterapia', d: 'Reserva tu fisio en MEFIR y estrena tu primera visita con descuento de bienvenida.' },
  ].filter(Boolean);

  // Contraseña SEGURA: mín. 8, mayúsculas+minúsculas, un número, y no de las típicas débiles.
  const _debiles = /^(?:1234\d*|12345678|123456789|0000+|1111+|password|passw0rd|contrasena|contraseña|qwerty|abcdef|admin\d*)$/i;
  const reglasPw = [
    { ok: pw1.length >= 8, txt: 'Al menos 8 caracteres' },
    { ok: /[a-z]/.test(pw1) && /[A-Z]/.test(pw1), txt: 'Mayúsculas y minúsculas' },
    { ok: /\d/.test(pw1), txt: 'Al menos un número' },
    { ok: pw1.length > 0 && !_debiles.test(pw1), txt: 'No una contraseña típica (12345…)' },
  ];
  const pwFuerte = reglasPw.every(r => r.ok);
  const pwOk = pwFuerte && pw1.length > 0 && pw1 === pw2;

  const wrap = {
    position: 'fixed', inset: 0, zIndex: 9999, overflowY: 'auto',
    background: "linear-gradient(rgba(8,20,16,.82),rgba(8,16,12,.92)), url('/fondo-canal.jpg') center/cover no-repeat, linear-gradient(160deg,#0c1f16,#06110d)",
    fontFamily: "'Montserrat', system-ui, sans-serif",
    display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '28px 18px 40px',
  };
  const card = {
    background: '#fff', borderRadius: 22, boxShadow: '0 18px 50px rgba(44,107,118,.16)',
    width: '100%', maxWidth: 460, padding: '30px 28px 28px', boxSizing: 'border-box',
  };

  // PASO 3: el tutorial va SOBRE EL MENÚ REAL (coach-marks). En vez de una tarjeta con la
  // info, se muestra el menú de aterrizaje y encima globos con letra grande señalando cada cosa.
  if (step === 2) {
    return <MenuConTutorial acceso={acceso} onFinish={onFinish} />;
  }

  return (
    <div style={wrap}>
      {/* Logo blanco Montserrat Medium arriba (mismo que la portada del canal) */}
      <div style={{ display: 'inline-block', textAlign: 'center', color: '#fff', lineHeight: 1, fontSize: 'clamp(22px,3.6vw,38px)', marginBottom: 22 }}>
        <div style={{ display: 'inline-flex', alignItems: 'flex-start', whiteSpace: 'nowrap', fontWeight: 500, letterSpacing: '.02em' }}>
          CANAL&nbsp;PILAR&nbsp;DOMÍNGUEZ
          <span style={{ fontSize: '.48em', fontWeight: 500, marginLeft: '.08em', alignSelf: 'flex-start', lineHeight: 1 }}>®</span>
        </div>
        <div style={{ fontSize: '0.25em', letterSpacing: '.14em', fontWeight: 500, marginTop: '0.8em', textTransform: 'uppercase', whiteSpace: 'nowrap' }}>Fisioterapia y ejercicio terapéutico online</div>
      </div>

      {/* Progreso */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 18 }}>
        {[0, 1, 2].map(i => (
          <span key={i} style={{ width: i === step ? 28 : 9, height: 9, borderRadius: 999, background: i <= step ? '#7fd8b8' : 'rgba(255,255,255,.28)', transition: '.25s' }} />
        ))}
      </div>

      <div style={card}>
        {/* PASO 1 · Crear contraseña */}
        {step === 0 && (
          <>
            <h1 style={{ margin: '0 0 4px', fontSize: 24, color: '#16323a', fontWeight: 800 }}>Crea una contraseña para empezar la suscripción</h1>
            <p style={{ margin: '0 0 22px', color: '#33474d', fontSize: 14.5 }}>¡Te quedan pocos pasos! Elige tu contraseña para tu Canal Pilar Domínguez.</p>

            <label style={{ fontWeight: 700, fontSize: 13, color: '#16323a' }}>Tu email</label>
            <input value={email} disabled style={{ ...inputStyle, background: '#f2f7f7', color: '#3a4e53', margin: '6px 0 16px' }} />

            <label style={{ fontWeight: 700, fontSize: 13, color: '#16323a' }}>Contraseña</label>
            <input type="password" value={pw1} onChange={e => setPw1(e.target.value)} placeholder="Mínimo 8 caracteres" style={{ ...inputStyle, margin: '6px 0 14px' }} />

            {pw1.length > 0 && (
              <div style={{ margin: '2px 0 8px', display: 'flex', flexDirection: 'column', gap: 4 }}>
                {reglasPw.map((r, i) => (
                  <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12.5, color: r.ok ? '#2f7d5a' : '#8a7a5a' }}>
                    <span style={{ width: 15, height: 15, borderRadius: '50%', flexShrink: 0, display: 'grid', placeItems: 'center', background: r.ok ? '#2f7d5a' : '#e2d9c6', color: '#fff', fontSize: 10 }}>{r.ok ? '✓' : ''}</span>
                    {r.txt}
                  </div>
                ))}
              </div>
            )}

            <div style={{ marginTop: 18 }}>
              <button style={pill(pwFuerte)} disabled={!pwFuerte} onClick={() => setStep(1)}>Siguiente →</button>
            </div>
          </>
        )}

        {/* PASO 2 · Mira tu correo (verificación por enlace) */}
        {step === 1 && !reenviado && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ width: 66, height: 66, borderRadius: '50%', background: 'rgba(60,134,150,.12)', display: 'grid', placeItems: 'center', margin: '2px auto 18px' }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={TEAL} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2.5" /><path d="m3 7 9 6 9-6" /></svg>
            </div>
            <h1 style={{ margin: '0 0 8px', fontSize: 24, color: '#16323a', fontWeight: 800 }}>Consulta tu buzón de entrada</h1>
            <p style={{ margin: '0 0 24px', color: '#33474d', fontSize: 14.5, lineHeight: 1.5 }}>Hemos enviado un enlace de verificación a <b>{email}</b>. Haz clic en el enlace del correo para confirmar tu cuenta.</p>
            <button style={pill(true)} onClick={onFinish}>Continuar →</button>
            <button onClick={() => setReenviado(true)} style={{ width: '100%', height: 40, marginTop: 12, borderRadius: 12, background: 'rgba(60,134,150,.10)', color: TEAL, border: '1px solid rgba(60,134,150,.35)', fontWeight: 600, fontSize: 14.5, cursor: 'pointer', fontFamily: 'inherit' }}>Reenviar enlace</button>
          </div>
        )}

        {/* PASO 2b · Pantalla "hemos reenviado" */}
        {step === 1 && reenviado && (
          <div style={{ textAlign: 'center' }}>
            <div style={{ width: 66, height: 66, borderRadius: '50%', background: 'rgba(47,125,90,.12)', display: 'grid', placeItems: 'center', margin: '2px auto 18px' }}>
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2f7d5a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="14" rx="2.5" /><path d="m3 7 9 6 9-6" /><path d="m16 12 2 2 4-4" /></svg>
            </div>
            <h1 style={{ margin: '0 0 8px', fontSize: 24, color: '#16323a', fontWeight: 800 }}>Enlace reenviado</h1>
            <p style={{ margin: '0 0 24px', color: '#33474d', fontSize: 14.5, lineHeight: 1.5 }}>Hemos vuelto a enviar el enlace de verificación a <b>{email}</b>. Mira tu correo (revisa también la carpeta de spam) y haz clic en el enlace para confirmar tu cuenta.</p>
            <button style={pill(true)} onClick={() => setStep(2)}>Continuar →</button>
            <button onClick={() => setReenviado(false)} style={{ width: '100%', height: 40, marginTop: 12, borderRadius: 12, background: 'rgba(60,134,150,.10)', color: TEAL, border: '1px solid rgba(60,134,150,.35)', fontWeight: 600, fontSize: 14.5, cursor: 'pointer', fontFamily: 'inherit' }}>Volver</button>
          </div>
        )}
      </div>

      {step < 2 && (
        <p style={{ marginTop: 18, color: '#5a7176', fontSize: 12.5 }}>Paso {step + 1} de 3</p>
      )}
    </div>
  );
}
